var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7542 12.3197C23.5907 11.8209 23.3072 11.3638 22.9129 10.9504C22.4997 10.5184 21.9568 10.1841 21.2835 9.94243C20.6095 9.70264 19.7442 9.58114 18.6778 9.58114H17.2307C17.4032 7.81586 18.0376 6.3135 19.1351 5.0715C20.2307 3.83336 21.7498 2.74371 23.6919 1.809L22.514 0C19.957 1.07936 17.7691 2.65821 15.9516 4.74364C14.1347 6.831 13.2298 8.89907 13.2298 10.9504C13.2298 13.1541 13.7546 14.8828 14.8125 16.1306C15.8705 17.3784 17.3857 18 19.3557 18C20.6056 18 21.6915 17.5866 22.6151 16.7606C23.5375 15.9358 24 14.9696 24 13.8677C24 13.3361 23.9189 12.8186 23.7542 12.3197ZM10.5243 12.3197C10.3596 11.8209 10.0768 11.3638 9.68173 10.9504C9.26983 10.5184 8.72627 10.1841 8.05233 9.94243C7.37968 9.70264 6.51438 9.58114 5.44736 9.58114H3.99958C4.17277 7.81586 4.80649 6.3135 5.90336 5.0715C6.99958 3.83336 8.52001 2.74371 10.4608 1.809L9.28347 0C6.72584 1.07936 4.53925 2.65821 2.72109 4.74364C0.904221 6.831 0 8.89907 0 10.9504C0 13.1541 0.523456 14.8828 1.58205 16.1306C2.6387 17.3784 4.15396 18 6.1252 18C7.3745 18 8.46162 17.5866 9.38529 16.7606C10.3077 15.9358 10.7695 14.9696 10.7695 13.8677C10.7695 13.3361 10.6871 12.8186 10.5243 12.3197Z",
    fill: "#3E236E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.31eee1e97e82bd78c2e293bb3e331248.svg";
export { ForwardRef as ReactComponent };